import React from 'react';
import PropTypes from 'prop-types';
import AssetService from "../../../services/AssetService";
import ImageGallery from 'react-image-gallery';
import Notify from "../../../services/Notify";
import Loading from "../../Loading/Loading";
import HttpRequest from './../../../services/HttpRequest';
import trashcanIcon from './trashcan_icon.png';
import cameraIcon from './camera_icon.png';

class AssetGallery extends React.Component {

  service = new AssetService();
  http = new HttpRequest();
  currentImageIndex = 0;

  constructor(props) {
    super(props);
    this.state = {asset: props.asset};
  }

  reloadImageGallery() {
    //window.location.reload();
    this.findAsset(this.props.asset)
    this.currentImageIndex = 0
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.asset.id !== nextProps.asset.id) {
      this.findAsset(nextProps.asset);
    }
  }

  componentWillMount() {
    const {asset} = this.props;
    this.findAsset(asset);
  }

  findAsset(asset) {
    this.setState({loading: true, message: null});
    this.service.findAllPhotos(asset.id).then(
        data => this.setState(
            {
              loading: false,
              images: data.content
            }),
        error => {
          const state = {loading: false, asset: null};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
    )
  }

  getCurrentImage() {
    const {images} = this.state;
    return images[this.currentImageIndex]
  }

  deleteCurrentImage() {
    const currentImage = this.getCurrentImage()
    this.deletePhoto(currentImage.id).then(() => {
      Notify.success("A imagem foi removida")
      this.reloadImageGallery()
    })
  }

  deletePhoto(assetPhotoId) {
    return this.http.delete(`ton/v1/asset-photos/${assetPhotoId}`)
  }

  getPhotoUrl(asset) {
    const assetId = asset.id;
    return this.http.post(`ton/v1/assets/${assetId}/photos/upload`, {});
  }

  activePhoto(assetPhoto) {
    const assetPhotoId = assetPhoto.id;
    return this.http.put(`ton/v1/asset-photos/${assetPhotoId}`, {});
  }

  onSlide(index) {
    this.currentImageIndex = index;
  }

  onClickDeleteButton() {
    this.deleteCurrentImage()
  }

  render() {
    const {images, loading, message} = this.state;

    if (loading) {
      return <Loading/>
    }

    if (message) {
      return message;
    }

    if (images.length === 0) {
      return <table>
        <td><h2>Sem imagens</h2></td>
        <div className="add-image-button" style={{position: 'relative', left: '4px'}}>
          <label htmlFor="file-input">
            <img src={cameraIcon}/>
          </label>

          <input id="file-input" type="file" accept=".png, .jpg, .jpeg" multiple onChange={event => {

            for (var index = 0; index < event.target.files.length; index++) {
              const blob = event.target.files[index]

              this.getPhotoUrl(this.props.asset).then(assetPhoto => {
                this.http.putS3(assetPhoto.url, assetPhoto.fileName, blob).then(
                    () => {
                      this.activePhoto(assetPhoto).then(() => {
                        Notify.success("A imagem foi adicionada ao asset")
                        this.reloadImageGallery()
                      })
                    },
                    error => {
                      Notify.error(error)
                    }
                );
              })
            }
          }}/>
        </div>
      </table>
    }
    const imgs = images.map(x => ({original: x.url, thumbnail: x.url}));

    return (<div>

      <div className="add-image-button">
        <label htmlFor="file-input">
          <img src={cameraIcon}/>
        </label>

        <input id="file-input" type="file" accept=".png, .jpg, .jpeg" multiple onChange={event => {

          for (var index = 0; index < event.target.files.length; index++) {
            const blob = event.target.files[index]

            this.getPhotoUrl(this.props.asset).then(assetPhoto => {
              this.http.putS3(assetPhoto.url, assetPhoto.fileName, blob).then(
                  () => {
                    this.activePhoto(assetPhoto).then(() => {
                      Notify.success("A imagem foi adicionada ao asset")
                      this.reloadImageGallery()
                    })
                  },
                  error => {
                    Notify.error(error)
                  }
              );
            })
          }
        }}/>
      </div>

      <input className="delete-image-button" type="image" src={trashcanIcon} onClick={this.deleteCurrentImage.bind(this)}/>

      <ImageGallery showThumbnails={false} showFullscreenButton={false} useBrowserFullscreen={false} showPlayButton={false} showBullets={true} items={imgs} onSlide={this.onSlide.bind(this)}/>
    </div>);
  };

}

AssetGallery.propTypes = {
  asset: PropTypes.object,
  tagId: PropTypes.string
};


export default AssetGallery;



// WEBPACK FOOTER //
// ./src/component/Asset/gallery/AssetGallery.js